var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.1666,
    r: 16,
    fill: "#EDF0F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8805 13.4567L16.0005 17.3367L12.1205 13.4567C11.7305 13.0667 11.1005 13.0667 10.7105 13.4567C10.3205 13.8467 10.3205 14.4767 10.7105 14.8667L15.3005 19.4567C15.6905 19.8467 16.3205 19.8467 16.7105 19.4567L21.3005 14.8667C21.6905 14.4767 21.6905 13.8467 21.3005 13.4567C20.9105 13.0767 20.2705 13.0667 19.8805 13.4567Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.987d088b2293701c93b8e3e3a11a4eb4.svg";
export { ForwardRef as ReactComponent };